import { handleActions } from 'redux-actions';
import * as telephonyActions from '../../actions/telephony';
export function emptyAudio() {
    return {
        name: null,
        chunk_urls: [],
        master_file_path: null,
        chunk_duration_in_secs: 0,
        id: null,
        original_as_mp3_url: null,
    };
}
function defaultCountry() {
    return {
        country: 'United States',
        country_code: 'US',
        country_prefix: 1,
    };
}
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
        list: 'succeeded',
        get: 'succeeded',
        create: 'succeeded',
        createGroup: 'succeeded',
        delete: 'succeeded',
        upload: 'succeeded',
        listMusic: 'succeeded',
        getByQuery: 'succeeded',
        verifyExternal: 'succeeded',
        searchStatus: 'succeeded',
        numTypeSearchStatus: 'succeeded',
        changeCountry: 'succeeded',
        nextPage: null,
        previousPage: null,
    },
    ui: {
        isNewAudioOpen: false,
        isHoldingOpen: false,
        isHoldModalOpen: false,
        confirmReleaseShown: false,
        editNumberShown: false,
        buyGroupShown: false,
        buyNumberShown: false,
        externalCallerIdModalShown: false,
        verifyPhoneNumberShown: false,
        searchModalShown: false,
    },
    numbers: [],
    dynamicOwnNumbers: [],
    selectedCountry: defaultCountry(),
    searchResult: {
        country: defaultCountry(),
        groups: [],
        numbers: [],
    },
    numTypeSearchResult: {
        country: defaultCountry(),
        groups: [],
        numbers: [],
    },
    verifyPhoneNumber: {
        phone_number: '',
        code: '',
    },
    selectedNumber: null,
    newNumber: null,
    newNumberLabel: '',
    allAudios: [],
    selectedAudio: emptyAudio(),
    jobIds: [],
};
// Destructure the telephony actions.
const { telephonyShowEditNumberModal, telephonyHideEditNumberModal, telephonySetLabel, telephonyGetAllNumbers, telephonyGetAllNumbersSucceeded, telephonyGetAllNumbersFailed, telephonyGetNumbersByQuery, telephonyGetNumbersByQuerySucceeded, telephonyGetNumbersByQueryFailed, telephonyReleaseNumber, telephonyReleaseNumberSucceeded, telephonyReleaseNumberFailed, telephonyShowReleaseNumberModal, telephonyHideReleaseNumberModal, telephonyUpdateNumber, telephonyUpdateNumberSucceeded, telephonyUpdateNumberFailed, telephonyBuyNumber, telephonyBuyNumberSucceeded, telephonyBuyNumberFailed, telephonyBuyGroupNumberDelivered, telephonyBuyGroup, telephonyBuyGroupSucceeded, telephonyBuyGroupFailed, telephonyShowBuyNumberModal, telephonyHideBuyNumberModal, telephonyShowExternalCallerIdModal, telephonyHideExternalCallerIdModal, telephonyVerifyExternalCallerId, telephonyVerifyExternalCallerIdSucceeded, telephonyVerifyExternalCallerIdFailed, telephonyShowSearchNumberModal, telephonyHideSearchNumberModal, telephonySearchNumbers, telephonySearchNumbersSucceeded, telephonySearchNumbersFailed, telephonySearchNumbersByNumType, telephonySearchNumbersByNumTypeSucceeded, telephonySearchNumbersByNumTypeFailed, telephonyChangeCountryCode, } = telephonyActions.actions;
// Reducer
export const telephony = handleActions({
    // Get all numbers
    [telephonyGetAllNumbers.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { get: 'loading' }) });
    },
    [telephonyGetAllNumbersSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { get: 'succeeded' }), numbers: action.payload.data.numbers });
    },
    [telephonyGetAllNumbersFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { get: 'failed' }) });
    },
    // Set label
    [telephonySetLabel.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { newNumberLabel: action.payload });
    },
    // Get numbers by query
    // @TODO: need to check if this can be merged with telephony/TELEPHONY_GET_QUERY_NUMBERS
    [telephonyGetNumbersByQuery.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
    },
    [telephonyGetNumbersByQuerySucceeded.toString()]: (state, action) => {
        const nextPage = action.payload.meta && action.payload.meta.next_page
            ? action.payload.meta.next_page
            : null;
        const prevPage = action.payload.meta && action.payload.meta.prev_page
            ? action.payload.meta.prev_page
            : null;
        return Object.assign(Object.assign({}, state), { dynamicOwnNumbers: action.payload.data && Array.isArray(action.payload.data.numbers)
                ? action.payload.data.numbers
                : [], meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded', nextPage: nextPage, previousPage: prevPage }) });
    },
    [telephonyGetNumbersByQueryFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
    },
    // Release Number
    [telephonyShowReleaseNumberModal.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { confirmReleaseShown: true }), selectedNumber: action.payload });
    },
    [telephonyHideReleaseNumberModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { confirmReleaseShown: false }), selectedNumber: null });
    },
    [telephonyReleaseNumber.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { delete: 'loading' }) });
    },
    [telephonyReleaseNumberSucceeded.toString()]: (state, action) => {
        const number = action.payload.e164_format;
        return Object.assign(Object.assign({}, state), { numbers: state.numbers.filter((n) => n.e164_format !== number), meta: Object.assign(Object.assign({}, state.meta), { delete: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { confirmReleaseShown: false }) });
    },
    [telephonyReleaseNumberFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { delete: 'failed' }) });
    },
    // Edit Number - Update Number name, record outbound calls
    [telephonyShowEditNumberModal.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { editNumberShown: true }), selectedNumber: action.payload.phoneNumber });
    },
    [telephonyHideEditNumberModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { editNumberShown: false }) });
    },
    [telephonyUpdateNumber.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { update: 'loading' }) });
    },
    [telephonyUpdateNumberSucceeded.toString()]: (state, action) => {
        let numbers = [...state.numbers];
        const updatedNumber = Object.assign({}, action.payload.data);
        const name = updatedNumber.name;
        const number = updatedNumber.e164_format;
        const record_outbound_calls = updatedNumber.record_outbound_calls;
        const foundNumber = Object.assign({}, numbers.find(({ e164_format }) => e164_format === number));
        if (foundNumber) {
            foundNumber.name = name; // update to new name.
            foundNumber.record_outbound_calls = record_outbound_calls;
            numbers = numbers.map((n) => n.e164_format === number.e164_format ? foundNumber : n);
        }
        return Object.assign(Object.assign({}, state), { numbers: numbers, meta: Object.assign(Object.assign({}, state.meta), { update: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { editNumberShown: false }) });
    },
    [telephonyUpdateNumberFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { update: 'failed' }) });
    },
    // Show or hide search number modal in Buy Number
    [telephonyShowSearchNumberModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { searchModalShown: true }) });
    },
    [telephonyHideSearchNumberModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { searchModalShown: false }) });
    },
    // Search national numbers in Buy Number
    [telephonySearchNumbers.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchStatus: 'loading' }) });
    },
    [telephonySearchNumbersSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchStatus: 'succeeded' }), searchResult: {
                country: state.selectedCountry,
                groups: action.payload.data.groups.groups,
                numbers: action.payload.data.numbers,
                next_page: action.payload.meta.next_page,
                prev_page: action.payload.meta.prev_page,
                // TODO: limit is not used, remove?
                limit: action.payload.data.groups.limit !== undefined
                    ? action.payload.data.groups.limit
                    : null,
            } });
    },
    [telephonySearchNumbersFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { searchStatus: 'failed' }) });
    },
    // Search local area numbers in Buy Number
    [telephonySearchNumbersByNumType.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { numTypeSearchStatus: 'loading' }) });
    },
    [telephonySearchNumbersByNumTypeSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { numTypeSearchStatus: 'succeeded' }), numTypeSearchResult: {
                country: state.selectedCountry,
                groups: action.payload.data.groups.groups,
                numbers: action.payload.data.numbers,
                next_page: action.payload.meta.next_page,
                prev_page: action.payload.meta.prev_page,
                // TODO: limit is not used, remove?
                limit: action.payload.data.groups.limit !== undefined
                    ? action.payload.data.groups.limit
                    : null,
            } });
    },
    [telephonySearchNumbersByNumTypeFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { numTypeSearchStatus: 'failed' }) });
    },
    // Change country code in CountryCodeSelector in Buy Number
    [telephonyChangeCountryCode.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { selectedCountry: action.payload });
    },
    // Show or hide Confirm Buy Number modals
    [telephonyShowBuyNumberModal.toString()]: (state, action) => {
        let buyNumberShown = false;
        let buyGroupShown = false;
        let newNumber = null;
        if (action.payload.number !== null) {
            buyNumberShown = true;
            newNumber = action.payload.number;
        }
        else if (action.payload.group !== null) {
            buyGroupShown = true;
            newNumber = action.payload.group;
        }
        return Object.assign(Object.assign({}, state), { newNumber: newNumber, ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: buyGroupShown, buyNumberShown: buyNumberShown, searchModalShown: false }) });
    },
    [telephonyHideBuyNumberModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { newNumber: null, ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: false, buyNumberShown: false }) });
    },
    // Buy Number
    [telephonyBuyNumber.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { create: 'loading' }) });
    },
    [telephonyBuyNumberSucceeded.toString()]: (state, action) => {
        const number = action.payload.data;
        let numbers = state.numbers.slice();
        const foundNumber = numbers.find(({ e164_format }) => e164_format === number.e164_format);
        if (foundNumber !== undefined) {
            numbers = numbers.map((n) => n.e164_format === number.e164_format ? number : n);
        }
        else {
            numbers.push(number);
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { create: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: false, buyNumberShown: false }), numbers: numbers, searchResult: Object.assign(Object.assign({}, state.searchResult), { numbers: [], groups: [] }), numTypeSearchResult: Object.assign(Object.assign({}, state.numTypeSearchResult), { numbers: [], groups: [] }) });
    },
    [telephonyBuyNumberFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { newNumber: null, meta: Object.assign(Object.assign({}, state.meta), { create: 'failed' }), ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: false, buyNumberShown: false }) });
    },
    // Buy Group Number modal
    [telephonyBuyGroup.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createGroup: 'loading' }) });
    },
    [telephonyBuyGroupSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createGroup: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: false, buyNumberShown: false }), numbers: state.numbers, searchResult: Object.assign(Object.assign({}, state.searchResult), { numbers: [], groups: [] }), numTypeSearchResult: Object.assign(Object.assign({}, state.numTypeSearchResult), { numbers: [], groups: [] }) });
    },
    [telephonyBuyGroupFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { createGroup: 'failed' }), ui: Object.assign(Object.assign({}, state.ui), { buyGroupShown: false, buyNumberShown: false }) });
    },
    [telephonyBuyGroupNumberDelivered.toString()]: (state, action) => {
        const newNumber = Object.assign({}, action.payload.result.data);
        const numbers = state.numbers.slice();
        const index = numbers.findIndex((number) => {
            return number.e164_format === newNumber.e164_format;
        });
        if (index && index > -1) {
            const number = Object.assign({}, numbers[index], newNumber);
            numbers[index] = number;
        }
        else {
            numbers.unshift(newNumber);
        }
        return Object.assign(Object.assign({}, state), { numbers: numbers, verifyPhoneNumber: {
                phone_number: '',
                code: '',
            }, meta: Object.assign({}, state.meta), ui: Object.assign(Object.assign({}, state.ui), { externalCallerIdModalShown: false, verifyPhoneNumberShown: false }) });
    },
    // Verify external caller ID
    [telephonyShowExternalCallerIdModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { externalCallerIdModalShown: true }) });
    },
    [telephonyHideExternalCallerIdModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { externalCallerIdModalShown: false }) });
    },
    [telephonyVerifyExternalCallerId.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { verifyExternal: 'loading' }) });
    },
    [telephonyVerifyExternalCallerIdSucceeded.toString()]: (state, action) => {
        const numberToVerify = Object.assign({}, action.payload.data);
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { verifyExternal: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { externalCallerIdModalShown: true, verifyPhoneNumberShown: true }), verifyPhoneNumber: {
                phone_number: numberToVerify.number.e164_format,
                code: numberToVerify.code,
                name: numberToVerify.name,
            } });
    },
    [telephonyVerifyExternalCallerIdFailed.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { verifyExternal: 'failed' }), ui: Object.assign(Object.assign({}, state.ui), { externalCallerIdModalShown: false, verifyPhoneNumberShown: false }) });
    },
}, initialState);
